import { useState } from "react";
import "./FilterPanel.css";

function FilterPanel({ onFilter }) {
  const [filters, setFilters] = useState({
    keyword: "",
    location: "",
    experience: "",
    jobType: [],
    workMode: [],
    jobCategory: [],
    postedDate: "",
    companyType: [],
  });

  const handleCheckboxChange = (e, filterKey) => {
    const { value, checked } = e.target;
    const updatedFilter = checked
      ? [...filters[filterKey], value]
      : filters[filterKey].filter((item) => item !== value);
    const updatedFilters = { ...filters, [filterKey]: updatedFilter };
    setFilters(updatedFilters);
    onFilter(updatedFilters);
  };

  const handleInputChange = (e, filterKey) => {
    const updatedFilters = { ...filters, [filterKey]: e.target.value };
    setFilters(updatedFilters);
    onFilter(updatedFilters);
  };

  const handleExperienceChange = (e) => {
    const updatedFilters = { ...filters, experience: e.target.value };
    setFilters(updatedFilters);
    onFilter(updatedFilters);
  };

  const handlePostedDateChange = (e) => {
    const updatedFilters = { ...filters, postedDate: e.target.value };
    setFilters(updatedFilters);
    onFilter(updatedFilters);
  };

  const handleResetFilters = () => {
    const resetFilters = {
      keyword: "",
      location: "",
      experience: "",
      jobType: [],
      workMode: [],
      jobCategory: [],
      postedDate: "",
      companyType: [],
    };
    setFilters(resetFilters);
    onFilter(resetFilters);
  };

  return (
    <div className="filter-panel">
      <div className="filter-header">
        <h2>Filters</h2>
        <button className="filter-close-btn" onClick={handleResetFilters}>
          Reset
        </button>
      </div>

      
      <div className="filter-section">
        <h3>Keyword</h3>
        <input
          type="text"
          placeholder="e.g., React Developer"
          value={filters.keyword}
          onChange={(e) => handleInputChange(e, "keyword")}
        />
      </div>

      
      <div className="filter-section">
        <h3>Location</h3>
        <input
          type="text"
          placeholder="e.g., Hyderabad"
          value={filters.location}
          onChange={(e) => handleInputChange(e, "location")}
        />
      </div>

      
      <div className="filter-section">
        <h3>Experience</h3>
        <select
          value={filters.experience}
          onChange={handleExperienceChange}
          className="dropdown-filter"
        >
          <option value="" disabled>
            Select Experience
          </option>
          <option value="Fresher">Fresher</option>
          <optgroup label="Grouped Ranges">
            <option value="0-1">0–1 Years</option>
            <option value="1-3">1–3 Years</option>
            <option value="3-5">3–5 Years</option>
            <option value="5-10">5–10 Years</option>
            <option value="10+">10+ Years</option>
          </optgroup>
        </select>
      </div>

      
      <div className="filter-section">
        <h3>Job Type</h3>
        <div className="filter-options">
          {["Full-Time", "Part-Time", "Contract", "Internship"].map((type) => (
            <label key={type} className="checkbox-label">
              <input
                type="checkbox"
                value={type}
                checked={filters.jobType.includes(type)}
                onChange={(e) => handleCheckboxChange(e, "jobType")}
              />
              {type}
            </label>
          ))}
        </div>
      </div>

      
      <div className="filter-section">
        <h3>Work Mode</h3>
        <div className="filter-options">
          {["On-site", "Hybrid", "Remote"].map((mode) => (
            <label key={mode} className="checkbox-label">
              <input
                type="checkbox"
                value={mode}
                checked={filters.workMode.includes(mode)}
                onChange={(e) => handleCheckboxChange(e, "workMode")}
              />
              {mode}
            </label>
          ))}
        </div>
      </div>

      
      <div className="filter-section">
        <h3>Job Category</h3>
        <div className="filter-options">
          {["IT", "Design", "Analytics", "Management"].map((category) => (
            <label key={category} className="checkbox-label">
              <input
                type="checkbox"
                value={category}
                checked={filters.jobCategory.includes(category)}
                onChange={(e) => handleCheckboxChange(e, "jobCategory")}
              />
              {category}
            </label>
          ))}
        </div>
      </div>

      
      <div className="filter-section">
        <h3>Posted Date</h3>
        <div className="filter-options">
          <select value={filters.postedDate} onChange={handlePostedDateChange}>
            <option value="">Any Time</option>
            <option value="24h">Last 24 Hours</option>
            <option value="7d">Last 7 Days</option>
            <option value="30d">Last 30 Days</option>
          </select>
        </div>
      </div>

      
      <div className="filter-section">
        <h3>Company Type</h3>
        <div className="filter-options">
          {["Startup", "MNC", "Government", "Non-Profit"].map((type) => (
            <label key={type} className="checkbox-label">
              <input
                type="checkbox"
                value={type}
                checked={filters.companyType.includes(type)}
                onChange={(e) => handleCheckboxChange(e, "companyType")}
              />
              {type}
            </label>
          ))}
        </div>
      </div>
    </div>
  );
}

export default FilterPanel;